import React, { FC } from 'react';
import { ProductStepper } from 'app/components/product/ProductStepper';
import { getProductTranslationKey } from 'app/functions/product';
import * as styles from './ProductList.scss';
import { ProductsId, productsConfig } from '@webc/meeseeks-ui-sdk';
import { ProductDataType } from 'app/models/types/store/product';
import { isNecCardSelector } from 'app/store/selectors';
import { useAppSelector } from 'app/hooks/appHooks';

export type ProductListProps = {
  products: { [key in ProductsId]?: ProductDataType };
  onSetProductQuantity: (x: ProductsId, y: number) => void;
  onProductMessagesSeen: (key: ProductsId, value: boolean) => void;
  productMessagesSeen: Record<string, boolean>;
  maxTotalPassengerCount?: number;
  passengerCount: number;
  tabTrapAction?: (e: React.KeyboardEvent) => void;
  usVeteransPromoted?: boolean;
};

export const ProductList: FC<ProductListProps> = ({
  products,
  onSetProductQuantity,
  maxTotalPassengerCount,
  passengerCount,
  productMessagesSeen,
  onProductMessagesSeen,
  tabTrapAction,
}) => {
  const isNecCard = useAppSelector(isNecCardSelector);

  const getMaxAmount = (product: ProductDataType) => {
    const requiredProducts = productsConfig.productTypes[product.id]?.requiredProductTypes;
    const blockSelectionIfInvalid =
      productsConfig.productTypes[product.id]?.blockSelectionForMissingRequiredProducts;
    if (!!requiredProducts?.length && blockSelectionIfInvalid) {
      const maxAmount = requiredProducts.reduce((acc, curr) => {
        return products[curr] ? acc + products[curr]?.selectedAmount : acc;
      }, 0);
      return maxAmount;
    }
    return product.maxAmount;
  };

  return (
    <div className={styles.productPicker}>
      {Object.keys(products).map((productType, i) => {
        let description = getProductTranslationKey(productType, 'description');

        if (productType === 'adult') {
          if (isNecCard) {
            description = getProductTranslationKey('sct_nec_adult', 'description');
          } else {
            description = '';
          }
        }

        if (productType === 'us_veteran') {
          description = '';
        }

        return (
          <ProductStepper
            key={productType}
            productType={productType as ProductsId}
            title={getProductTranslationKey(productType, 'label')}
            description={description}
            onChange={(newQuantity) => {
              onSetProductQuantity(productType as ProductsId, newQuantity);
            }}
            value={products[productType].selectedAmount}
            max={getMaxAmount(products[productType])}
            maxTotalPassengerCount={maxTotalPassengerCount}
            passengerCount={passengerCount}
            onProductMessagesSeen={onProductMessagesSeen}
            productMessagesSeen={productMessagesSeen}
            tabTrapAction={i + 1 === Object.keys(products).length ? tabTrapAction : undefined}
          />
        );
      })}
    </div>
  );
};

export default ProductList;
